import { ReportFeatures } from '@hcs/types';

export const REPORT_VALUE_FEATURES_SALE = [
  ReportFeatures.HcAvm,
  ReportFeatures.AdjustedAvm,
  ReportFeatures.ComparableValue,
  ReportFeatures.UserOpinionOfPrice,
];

export const REPORT_VALUE_FEATURES_RENTAL = [
  ReportFeatures.RentalHcAvm,
  ReportFeatures.RentalComparableValue,
  ReportFeatures.RentalUserOpinionOfPrice,
];
